import React from 'react'
import PartnerIbanTable from '../components/PartnerIbanTable/PartnerIbanTable'

const PartnersView = () => {
  return <PartnerIbanTable />
}

export default PartnersView
